import { render, staticRenderFns } from "./editdealer.vue?vue&type=template&id=afdb9cba&scoped=true&"
import script from "./editdealer.vue?vue&type=script&lang=js&"
export * from "./editdealer.vue?vue&type=script&lang=js&"
import style0 from "./editdealer.vue?vue&type=style&index=0&id=afdb9cba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdb9cba",
  null
  
)

export default component.exports